import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import i18n from 'simple-react-i18n'
import SieauAction from '../../../components/sieau/SieauAction'
import InstallationAction from '../../actions/InstallationAction'
import { getStationArrowNav } from '../../../utils/ActionUtils'
import { getLinks } from '../../../utils/StationUtils'
import InstallationSampleCharacteristicsPanel from '../installations/components/InstallationSampleCharacteristicsPanel'
import InstallationOuvragePanel from '../installations/components/InstallationOuvragePanel'
import StationTanksPanel from '../../../station/components/link/StationTanksPanel'
import WatershedAction from '../../../referencial/components/watershed/actions/WatershedAction'
import AquiferAction from '../../../referencial/components/aquifers/actions/AquiferAction'
import HydrogeologicalEntityAction from '../../../referencial/components/hydrogeologicalEntity/actions/HydrogeologicalEntityAction'
import StationAction from '../../../station/actions/StationAction'
import QualityAction from '../../../quality/actions/QualityAction'
import BuildingsPanel from '../installations/components/BuildingsPanel'
import AgriAction from 'agriAdministration/actions/AgriAction'
import { Card, CardContent, Grid } from '@mui/material'
import GenericInstallationDescription from '../installationDefault/GenericInstallationDescription'
import { CardTitle } from 'components/card/NewCard'
import useActions from 'utils/customHook/useActions'

const AgriPrelDescriptionPanel = ({ onRemount, onChangeVisit }) => {
    const [readMode, setReadMode] = useState(true)
    const [newInstallation, setNewInstallation] = useState({})

    const {
        watersheds,
        aquifers,
        hydrogeologicalEntities,
        installationAgriTanks,
        natures,
        fieldModes,
        status,
        installation,
        installationTable,
        // installationVisits,
        accountUser,
        agriTanksTypes,
    } = useSelector(store => ({
        watersheds: store.WatershedReducer.watersheds,
        aquifers: store.AquiferReducer.aquifers,
        hydrogeologicalEntities: store.HydrogeologicalEntityReducer.hydrogeologicalEntities,
        installationAgriTanks: store.InstallationReducer.installationAgriTanks,
        natures: store.StationReducer.natures,
        fieldModes: store.StationReducer.fieldModes,
        status: store.QualityReducer.status,
        installation: store.InstallationReducer.installation,
        installationTable: store.InstallationReducer.installationTable,
        // installationVisits: store.InstallationReducer.installationVisits,
        accountUser: store.AccountReducer.accountUser,
        agriTanksTypes: store.AgriReducer.agriTanksTypes,
    }), shallowEqual)

    const dispatch = useDispatch()

    useActions(() => {
        // const visitExport = installationVisits.length ? { export: () => createAndDownloadEdition(installationVisits[0]) } : null
        const actions = {
            // ...visitExport,
            links: getLinks(installation, { onRemount, onChangeVisit }),
            arrowNav: getStationArrowNav('installation', installationTable, installation?.id, s => dispatch(push(`/station/installation/${s?.id}/description`))),
        }
        const editionActions = readMode ? {
            edit: () => setReadMode(false),
        } : {
            save: () => dispatch(InstallationAction.updateInstallation(newInstallation)).then(() => setReadMode(true)),
            cancel: () => {
                setNewInstallation(installation)
                setReadMode(true)
            },
        }
        if (accountUser?.consultant === '1') {
            return ({ ...actions })
        }
        return ({
            ...actions,
            ...{
                ...editionActions,
                delete: () => dispatch(SieauAction.delete('installation', installation.id, dispatch(push('/installation')))),
            },
        })
    }, [readMode, newInstallation])

    useEffect(() => {
        if (installation?.id) {
            setNewInstallation(installation)
        }
        if (onChangeVisit) {
            setReadMode(false)
        } else {
            setReadMode(true)
        }
        if (!watersheds?.length) {
            dispatch(WatershedAction.fetchWatersheds())
        }
        if (!aquifers?.length) {
            dispatch(AquiferAction.fetchAquifers())
        }
        if (!hydrogeologicalEntities?.length) {
            dispatch(HydrogeologicalEntityAction.fetchHydrogeologicalEntities())
        }
        if (!installationAgriTanks?.length) {
            dispatch(InstallationAction.fetchInstallationAgriTanks())
        }
        if (!natures?.length) {
            dispatch(StationAction.fetchNatures())
        }
        if (!fieldModes?.length) {
            dispatch(StationAction.fetchFieldModes())
        }
        if (!status?.length) {
            dispatch(QualityAction.fetchStatus())
        }
        if (!agriTanksTypes?.length) {
            dispatch(AgriAction.fetchTanksTypes())
        }

        // dispatch(InstallationAction.fetchInstallationVisits(installation.id)).then(() => {
        //     if (onChangeVisit) {
        //         setReadMode(false)
        //     } else {
        //         setReadOnlyMode()
        //     }
        // })
    }, [])

    // const createAndDownloadEdition = (installationVisit) => {
    //     dispatch(InstallationAction.getEditionInstallation(installationVisit.idCampaign, installation.id)).then(json => {
    //         downloadURI(json.targetPath)
    //     })
    // }

    const onChangeInstallation = (newObject) => {
        setNewInstallation({ ...newInstallation, ...newObject })
    }

    const onChangeVisitValidation = (visitObject) => {
        if (visitObject && onChangeVisit) {
            onChangeVisit(visitObject)
        }
    }

    const params = {
        station: newInstallation,
        onChange: onChangeInstallation,
        onChangeVisit: onChangeVisitValidation,
        readMode,
    }

    return (
        <GenericInstallationDescription
            readMode={readMode}
            installation={newInstallation}
            onChangeInstallation={onChangeInstallation}
            onChangeVisit={onChangeVisitValidation}
            descElements={
                <>
                    <Grid size={12}>
                        <BuildingsPanel {...params} />
                    </Grid>
                </>
            }
            otherElements={
                <>
                    <Grid size={12}>
                        <Card>
                            <CardTitle title={i18n.characteristics} />
                            <CardContent>
                                <Grid container columnSpacing={1}>
                                    <InstallationSampleCharacteristicsPanel {...params} />
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={12}>
                        <Card>
                            <CardTitle title={i18n.work} />
                            <CardContent>
                                <Grid container columnSpacing={1}>
                                    <InstallationOuvragePanel {...params} />
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={12}>
                        <StationTanksPanel {...params} />
                    </Grid>
                </>
            }
        />
    )
}

AgriPrelDescriptionPanel.propTypes = {
    onRemount: PropTypes.func,
    onChangeVisit: PropTypes.func, // used for changes on visit mode only
}

export default AgriPrelDescriptionPanel
